var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "houseHome-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-28.371 1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "houseHome",
    transform: "translate(28.371 -1)",
    clipPath: "url(#houseHome-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3,9.891,19.65,2,1,9.891",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.871,21.838V41.724H36.637V21.838",
    transform: "translate(-2.607 -7.528)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseHome);
export default __webpack_public_path__ + "static/media/houseHome.ac565d1fe18e816c11def9c35c2dfc23.svg";
export { ForwardRef as ReactComponent };